<forge-text-field [invalid]="isInvalid" data-lpignore="true" float-label-type
    [attr.shape]="forCellEdit ? 'squared' : null"
    [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [density]="density" [required]="isRequired"
    [attr.label-position]="LabelPosition">
  <input #input [type]="InputType.toLowerCase()" [disabled]="isViewOnly" [id]="controlId" [(ngModel)]="valueModel"
        [pattern]="Regex" (input)="onInputChange()" (change)="onChange()" [required]="isRequired"
        [maxlength]="MaxLength" [minlength]="MinLength" [name]="Name" focusOnLoad [propertyMetadata]="propertyMetadata"
        [forCellEdit]="forCellEdit" (keydown)="onKeydown($event)" (keyup)="updateCurrentLength($event)"
        data-lpignore="true" autocomplete="off" attr.telemetry="Edit-{{Label}}" tabindex="0">
    <label [for]="controlId">{{Label}}</label>
    @if (showCounter) {
    <span slot="support-text" style="float: right;">{{currentLength || 0}}/{{MaxLength}}</span>
    }
    @if (showHint) {
    <span slot="support-text">{{hint}}</span>
    }
    @if (showError) {
    <span slot="support-text" class="error-red">{{error}}</span>
    }
    @if (showSpinner) {
    <forge-circular-progress class="metadata-input--spinner" slot="end">
    </forge-circular-progress>
    }
    @if (forCellEdit) {
    <forge-focus-indicator slot="focus-indicator" inward></forge-focus-indicator>
    }
</forge-text-field>